import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { FoundPeopleWizard } from "@/features/appointments/components/found-people-wizard"
import { appointmentQueries } from "@/queries/appointments"
import { foundPeopleQueries } from "@/queries/found-people"
import { involvementTypeQueries } from "@/queries/involvement-types"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/people/add/"
)({
  staticData: { attention: "firm.people" },
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(involvementTypeQueries.families())
    void context.queryClient.prefetchQuery(
      appointmentQueries.listForFirm(params.firmId)
    )

    return context.queryClient.ensureQueryData(
      foundPeopleQueries.forFirm(params.firmId)
    )
  },
  component: AddPeoplePage,
})

function AddPeoplePage() {
  const { firmId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <FoundPeopleWizard
      firmId={firmId}
      onFinished={() =>
        void navigate({
          from: "/$organisation",
          to: "/$organisation/firms/$firmId/people",
          params: { firmId },
        })
      }
    />
  )
}
